<template>
  <el-container>
    <el-container class="application-container" v-loading="loading">
      <el-header>
        <el-menu
          :default-active="$route.path"
          :router="true"
          background-color="#07344C"
          text-color="#ffff"
          active-text-color="#ffd04b"
          mode="horizontal"
          class="general-menu"
        >
          <el-menu-item index="/dashboard" class="menu-item-desktop">
            <i class="menu-icon">
              <font-awesome-icon icon="chart-bar" />
            </i>
            <span>Dashboard</span>
          </el-menu-item>

          <el-submenu index="grupo-aluguel" v-if="usuarioLogado.imobiliaria.moduloAluguel" class="menu-item-desktop">
            <template slot="title">
              <i class="menu-icon">
                <font-awesome-icon icon="building" />
              </i>
              <span>Aluguel</span>
            </template>
            <el-menu-item index="/alugueis/clientes" v-if="permissoesClientesAluguel && permissoesClientesAluguel.visualizacao">
              <span>Clientes</span>
            </el-menu-item>
            <el-menu-item index="/alugueis" v-if="permissoesContratosAluguel && permissoesContratosAluguel.visualizacao">
              <span>Contratos</span>
            </el-menu-item>
            <el-menu-item index="/alugueis/imoveis" v-if="permissoesImoveisAluguel && permissoesImoveisAluguel.visualizacao">
              <span>Imóveis</span>
            </el-menu-item>
            <el-submenu index="grupo-relatorios-alugueis" v-if="exibirRelatoriosAluguel">
              <template slot="title">
                <span>Relatórios</span>
              </template>
              <el-menu-item @click="visibilidadeGerarRelatoriosClientesAluguel = true" v-if="exibirRelatoriosClientesAluguel" index="#relatoriosClientesAluguel">
                <span>Relatórios de Clientes</span>
              </el-menu-item>
              <el-menu-item @click="visibilidadeGerarRelatoriosContratosAluguel = true" v-if="exibirRelatoriosContratosAluguel" index="#relatoriosContratosAluguel">
                <span>Relatórios de Contratos</span>
              </el-menu-item>
              <el-menu-item @click="visibilidadeGerarRelatoriosImoveisAluguel = true" v-if="exibirRelatoriosImoveisAluguel" index="#relatoriosImoveisAluguel">
                <span>Relatórios de Imóveis</span>
              </el-menu-item>
              <el-menu-item @click="visibilidadeGerarRelatoriosPretendentesAluguel = true" v-if="exibirRelatoriosPretendentesAluguel" index="#relatoriosPretendentesAluguel">
                <span>Relatórios de Pretendentes</span>
              </el-menu-item>
              <el-menu-item @click="visibilidadeGerarRelatoriosFinanceirosAluguel = true" v-if="exibirRelatoriosFinanceirosAluguel" index="#relatoriosFinanceirosAluguel">
                <span>Relatórios Financeiros</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-if="false" index="/parcerias">
              <span>Parcerias</span>
            </el-menu-item>
            <el-submenu index="baixas" v-if="exibirBaixasAluguel">
              <template slot="title">
                <span>Baixas</span>
              </template>
              <el-menu-item index="/alugueis/baixasAlugueis" v-if="permissoesClientesAluguel.pagarAluguel">
                <span>Alugueis</span>
              </el-menu-item>
              <el-menu-item index="/alugueis/baixasRetornoBancario" v-if="permissoesClientesAluguel.processarArquivoBancario">
                <span>Arquivo de Retorno Bancário</span>
              </el-menu-item>
              <el-menu-item index="/alugueis/baixasRepasses" v-if="permissoesClientesAluguel.liberarRepasse">
                <span>Repasses</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="remessasRegistros">
              <template slot="title">
                <span>Remessas/Titulos via API</span>
              </template>
              <el-menu-item index="/alugueis/remessasBancarias" v-if="permissoesClientesAluguel && permissoesClientesAluguel.gerarRemessaBancaria">
                <span>Geração de Remessas</span>
              </el-menu-item>
              <el-submenu index="titulosApi" v-if="(permissoesClientesAluguel && permissoesClientesAluguel.controleTitulosApi) || (permissoesClientesAluguel && permissoesClientesAluguel.registrarTitulosApi)">
                <template slot="title">
                  <span>Títulos via API</span>
                </template>
                <el-menu-item index="/alugueis/registrosApi" v-if="permissoesClientesAluguel.registrarTitulosApi">
                  <span>Registrar Títulos</span>
                </el-menu-item>
                <el-menu-item index="/alugueis/controleRegistroApi" v-if="permissoesClientesAluguel.controleTitulosApi">
                  <span>Controle de Títulos</span>
                </el-menu-item>
              </el-submenu>
            </el-submenu>
            <el-menu-item index="/alugueis/dimob" v-if="permissoesContratosAluguel && permissoesContratosAluguel.visualizarDimob">
              <span>DIMOB</span>
            </el-menu-item>
            <el-menu-item index="/alugueis/vistorias" v-if="usuarioLogado.imobiliaria.appVistoria">
              <span slot="title">Vistorias</span>
            </el-menu-item>
          </el-submenu>

          <el-submenu index="grupo-vendas" v-if="usuarioLogado.imobiliaria.moduloVenda" class="menu-item-desktop">
            <template slot="title">
              <i class="menu-icon">
                <font-awesome-icon icon="building" />
              </i>
              <span>Vendas</span>
            </template>

            <el-menu-item index="/clientes" v-if="exibirClientesVenda">
              <span>Clientes</span>
            </el-menu-item>
            <el-menu-item index="/vendas" v-if="exibirContratosVenda">
              <span>Contratos</span>
            </el-menu-item>
            <el-menu-item index="/imoveis" v-if="exibirImoveisVenda">
              <span>Imóveis</span>
            </el-menu-item>
            <el-submenu index="grupo-relatorios-vendas" v-if="exibirRelatoriosVenda">
              <template slot="title">
                <span>Relatórios</span>
              </template>

              <el-menu-item @click="visibilidadeGerarRelatorioCaptacao = true" v-if="exibirRelatoriosCaptacoes" index="#relatoriosDesempenhoCaptacao">
                <span>Desempenho de Captação</span>
              </el-menu-item>
              <el-menu-item @click="visibilidadeGerarRelatorioComissoes = true" v-if="exibirRelatoriosComissoes" index="#relatoriosComissoes">
                <span>Relatórios de Comissões</span>
              </el-menu-item>
              <el-menu-item @click="visibilidadeGerarRelatorioClientes = true" v-if="exibirRelatoriosClientes" index="#relatoriosClientesVenda">
                <span>Relatórios de Clientes</span>
              </el-menu-item>
              <el-menu-item @click="visibilidadeGerarRelatorioImoveis = true" v-if="exibirRelatoriosImoveis" index="#relatoriosImoveisVenda">
                <span>Relatórios de Imóveis</span>
              </el-menu-item>
              <el-menu-item @click="visibilidadeGerarRelatorioPretendentes = true" v-if="exibirRelatoriosPretendentes" index="#relatoriosPretendentesVenda">
                <span>Relatórios de Pretendentes</span>
              </el-menu-item>
            </el-submenu>
          </el-submenu>

          <el-submenu index="grupo-financeiro" v-if="usuarioLogado.imobiliaria.moduloFinanceiro" class="menu-item-desktop">
            <template slot="title">
              <i class="el-icon-s-marketing"></i>
              <span>Financeiro</span>
            </template>

            <el-menu-item index="/financeiro/ContasReceber" v-if="exibirContasReceber">
              <span>Contas a Receber</span>
            </el-menu-item>
            <el-menu-item index="/financeiro/ContasPagar" v-if="exibirContasPagar">
              <span>Contas a Pagar</span>
            </el-menu-item>
            <el-submenu index="cadastrosGerais">
              <template slot="title">Cadastros Gerais</template>
              <el-menu-item index="/financeiro/tiposConta" v-if="exibirGruposConta">
                <span>Tipos de Conta</span>
              </el-menu-item>
              <el-menu-item index="/financeiro/gruposConta" v-if="exibirGruposConta">
                <span>Grupos de Conta</span>
              </el-menu-item>
              <el-menu-item index="/financeiro/subGruposConta" v-if="exibirGruposConta">
                <span>Subgrupo de Conta</span>
              </el-menu-item>
              <el-menu-item index="/financeiro/planosConta" v-if="exibirPlanosConta">
                <span>Planos de Conta</span>
              </el-menu-item>
              <el-menu-item index="/financeiro/fornecedores" v-if="exibirFornecedores">
                <span>Fornecedores</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="#relatoriosFinanceiros" @click="visibilidadeGerarRelatoriosFinanceiros = true" v-if="exibirRelatoriosFinanceiros">
              <span>Relatórios</span>
            </el-menu-item>
            <el-menu-item index="/financeiro/remessasBancarias">
              <span>Remessas Bancárias</span>
            </el-menu-item>
            <el-menu-item index="/financeiro/retornoBancario">
              <span>Retorno Bancário</span>
            </el-menu-item>
          </el-submenu>

          <el-submenu index="grupo-configuracoes" class="menu-item-desktop">
            <template slot="title">
              <i class="menu-icon">
                <font-awesome-icon icon="cog" />
              </i>
              <span>Configurações</span>
            </template>

            <el-submenu index='imoveis'>
              <template slot="title">Cadastros Básicos</template>

              <el-menu-item index="/configuracoes/administradoras" v-if="exibirAdministradoras">
                <span>Administradoras</span>
              </el-menu-item>

              <el-menu-item index="/configuracoes/condominios" v-if="exibirCondominios">
                <span>Condomínios</span>
              </el-menu-item>

              <el-menu-item index="/configuracoes/placas" v-if="exibirPlacas">
                <span>Placas</span>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="assinaturaDocumentos">
              <template slot="title">Assinatura e Documentos</template>
              
              <el-menu-item index="/configuracoes/assinaturaEletronica" v-if="usuarioLogado.imobiliaria.id = 4">
                <span>Assinatura Eletrônica</span>
              </el-menu-item>

              <el-menu-item index="/configuracoes/formularios" v-if="exibirFormularios">
                <span>Gerenciamento de Formulários</span>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="usuarios">
              <template slot="title">Gestão de Usuários</template>
            
              <el-menu-item index="/configuracoes/usuarios" v-if="exibirUsuarios">
                <span>Usuários Cadastrados</span>
              </el-menu-item>

              <el-menu-item index="/configuracoes/perfis-usuario" v-if="exibirPerfisUsuarios">
                <span>Criação de Perfis</span>
              </el-menu-item>
            </el-submenu>

            <el-menu-item index="/configuracoes/contas-bancarias" v-if="exibirContasBancarias">
              <span>Contas para Boletos</span>
            </el-menu-item>
            
            <el-menu-item index="/configuracoes/portais" v-if="exibirPortais">
              <span>Portais de Anúncios</span>
            </el-menu-item>
            <el-menu-item index="/configuracoes/parametros" v-if="exibirParametros">
              <span>Parâmetros do Sistema</span>
            </el-menu-item>
            <el-menu-item index="/configuracoes/logs-acesso" v-if="exibirLogs">
              <span>Logs do Sistema</span>
            </el-menu-item>
            <el-menu-item index="/configuracoes/site" v-if="exibirSite">
              <span>Site da Imobiliária</span>
            </el-menu-item>
            <el-menu-item index="/configuracoes/rede-imob">
              <span>Rede IMOB</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item index="/#" @click="logoutSistema()" class="menu-item-desktop">
            <i class="menu-icon">
              <font-awesome-icon icon="sign-out-alt" />
            </i>
            <span>Sair</span>
          </el-menu-item>

          <el-menu-item class="drawer-menu" @click="openCloseSideMenu()">
            <i class="menu-icon">
              <font-awesome-icon :icon="sideMenuOpen ? 'times' : 'bars'" />
            </i>
          </el-menu-item>
        </el-menu>

        <div style="position: absolute; top: 10px; right: 0px; color: #FFFFFF; padding-right: 20px; font-size: 14px; font-weight: bold; display: flex; flex-direction: row; justify-content: center; align-items: center;">
          <el-badge :hidden="countNotificacoesNaoVisualizadas == 0" :value="countNotificacoesNaoVisualizadas" :max="99" class="item" style="margin-right: 10px;">
            <el-popover
              placement="bottom"
              trigger="click"
              name="popover-notifications"
            >
              <div class="container-notifications-not" v-if="notificacoes.length > 0 && !this.isExibirDetalheNotificacao">
                <table class="table-notifications">
                  <tr 
                    v-for="notificacao in notificacoes"
                    :key="notificacao.id"
                    style="width: 100%;"
                  >
                    <td class="notification-cell" :style="{ backgroundColor: notificacao.status === 'NAO_VISUALIZADA' ? '#ffffff' : '#d4d4d4' }" @dblclick="exibirDetalhesNotificacoes(notificacao)">
                      <div style="display: flex; flex-direction: row; font-size: 13px; font-weight: 600; justify-content: space-between; border-bottom: 1px solid grey; height: 1.4em; width: 100%;">
                        <span>{{ getLabel(moduloNotificacao, notificacao.modulo) }} <span style="font-size: 10px; font-style: italic;">{{ getLabel(tipoNotificacao, notificacao.tipo) }}</span></span>
                      </div>
                      <div class="no-wrap-description" style="font-size: 12px; padding: 4px 0px 0px 0px; word-break: normal; text-align: left; width: 23em;">
                        <div v-if="notificacao.tipo !== 'RECIBOS_NAO_REGISTRADOS'">
                          {{ notificacao.descricao }}
                        </div>
                        <div v-else>Detalhes dos recibos não registrados ao abrir a notificação...</div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>

              <div class="container-no-notifications" style="text-align: center; color: #FFFFFF;" v-if="!this.isExibirDetalheNotificacao && notificacoes.length === 0">
                <span>Não há notificações.</span>
              </div>

              <div class="container-notifications-detail animation-tb-detail-in" v-if="isExibirDetalheNotificacao" style="color: #1D1E1F;">
                <div class="details-notifications">
                  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                    <el-button @click="isExibirDetalheNotificacao=false" type="text" icon="el-icon-caret-left" style="font-size: large;"/>
                    <span style="font-size: 13px; font-weight: 600;">
                      {{ notificacaoEmExibicao.id ? getLabel(moduloNotificacao, notificacaoEmExibicao.modulo) : '' }}
                    </span>
                  </div>
                  <div style="padding: 4px 8px 0px 8px; display: flex; flex-direction: row-reverse;">
                    <span @click="redirectNotificacao(notificacaoEmExibicao)" class="direct-button" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ getDataModule(notificacaoEmExibicao) }}</span>
                  </div>
                  <div style="font-size: 12px; padding: 15px 8px 0px 8px; word-break: normal; text-align: left; text-overflow: ellipsis;">
                    <div v-if="notificacaoEmExibicao.tipo !== 'RECIBOS_NAO_REGISTRADOS'">
                          {{ notificacaoEmExibicao.descricao }}
                        </div>
                        <div v-else v-html="notificacaoEmExibicao.descricao"></div>
                  </div>
                </div>
              </div>
              <el-avatar slot="reference" class="avatar">{{ usuarioLogado.nome[0] }}</el-avatar>
            </el-popover>
          </el-badge>
          <span class="nome-usuario">{{ usuarioLogado.nome }}</span>
        </div>
      </el-header>

      <el-container class="full-height">
        <el-aside width="65px" style="height: 100%;">
          <el-menu :default-active="$route.path" :router="true" background-color="#07344C" text-color="#fff" active-text-color="#ffd04b" collapse style="height: 100%" class="general-menu">
            <!-- ALUGUEL -->
            <div v-if="usuarioLogado.imobiliaria.moduloAluguel">
              <div style="width: 100%; text-align: center">
                <span style="font-size: 12px; font-weight: bold; color: #FFFFFF">Aluguel</span>
              </div>
              <el-menu-item index="/alugueis/clientes" v-if="permissoesClientesAluguel && permissoesClientesAluguel.visualizacao" style="height: 50px;">
                <i class="el-icon-user-solid"></i>
                <span slot="title">Clientes Aluguel</span>
              </el-menu-item>
              <el-menu-item index="/alugueis" v-if="permissoesContratosAluguel && permissoesContratosAluguel.visualizacao" style="height: 50px">
                <i class="el-icon-notebook-1"></i>
                <span slot="title">Contratos Aluguel</span>
              </el-menu-item>
              <el-menu-item index="/alugueis/imoveis" v-if="permissoesImoveisAluguel && permissoesImoveisAluguel.visualizacao" style="height: 50px">
                <i class="el-icon-school"></i>
                <span slot="title">Imóveis Aluguel</span>
              </el-menu-item>
            </div>

            <!-- VENDA -->
            <div v-if="usuarioLogado.imobiliaria.moduloVenda">
              <div style="width: 100%; text-align: center">
                <span style="font-size: 12px; font-weight: bold; color: #FFFFFF">Venda</span>
              </div>
              <el-menu-item index="/clientes" v-if="exibirClientesVenda" style="height: 50px">
                <i class="el-icon-user-solid"></i>
                <span slot="title">Clientes Venda</span>
              </el-menu-item>
              <el-menu-item index="/vendas" v-if="exibirContratosVenda" style="height: 50px">
                <i class="el-icon-notebook-1"></i>
                <span slot="title">Contratos Venda</span>
              </el-menu-item>
              <el-menu-item index="/imoveis" v-if="exibirImoveisVenda" style="height: 50px">
                <i class="el-icon-school"></i>
                <span slot="title">Imóveis Venda</span>
              </el-menu-item>
            </div>

            <!-- OUTROS -->
            <div style="width: 100%; text-align: center">
              <span style="font-size: 12px; font-weight: bold; color: #FFFFFF">Outros</span>
            </div>
            <el-menu-item index="/caixa" v-if="exibirCaixa" style="height: 47px">
              <i class="el-icon-money"></i>
              <span slot="title">Caixa</span>
            </el-menu-item>
            <el-menu-item index="/atendimentos" v-if="exibirAtendimentoVenda" style="height: 47px">
              <i class="el-icon-headset"></i>
              <span slot="title">Atendimentos</span>
            </el-menu-item>
            <el-menu-item index="/historicoCobranca" v-if="permissaoHistoricoCobranca" style="height: 47px">
              <i class="el-icon-date"></i>
              <span slot="title">Histórico de Comunicações</span>
            </el-menu-item>
          </el-menu>
        </el-aside>

        <el-main class="application-main">
          <router-view />
        </el-main>
      </el-container>

      <div style="position: absolute; z-index: 1000; width: 235px; top: 59px; height: calc(100% - 58px) ;" 
        :class="`${sideMenuOpen ? 'animation-show-side-menu' : 'close-side-menu'}`" @click.stop>
        <el-menu :default-active="$route.path" :router="true" background-color="#07344C" text-color="#fff" active-text-color="#ffd04b" style="height: 100%; overflow-y: auto;" class="general-menu no-scrollbar">
          
          <el-menu-item index="/dashboard" @click="toggleMenu">
            <i class="el-icon-data-analysis"></i>
            <span slot="title">Dashboard</span>
          </el-menu-item>

          <!-- ALUGUEL -->
          <el-submenu index="grupo-aluguel" v-if="usuarioLogado.imobiliaria.moduloAluguel">
            <template slot="title">
              <i class="el-icon-s-management"></i>
              <span>Aluguel</span>
            </template>
            <el-menu-item @click="toggleMenu" index="/alugueis/clientes" v-if="permissoesClientesAluguel && permissoesClientesAluguel.visualizacao">
              <i class="el-icon-user-solid"></i>
              <span slot="title">Clientes</span>
            </el-menu-item>
            <el-menu-item @click="toggleMenu" index="/alugueis" v-if="permissoesContratosAluguel && permissoesContratosAluguel.visualizacao">
              <i class="el-icon-document-copy"></i>
              <span slot="title">Contratos</span>
            </el-menu-item>
            <el-menu-item @click="toggleMenu" index="/alugueis/imoveis" v-if="permissoesImoveisAluguel && permissoesImoveisAluguel.visualizacao" style="height: 50px">
                <i class="el-icon-school"></i>
                <span slot="title">Imóveis</span>
              </el-menu-item>
            <el-menu-item @click="toggleMenu" index="/alugueis/vistorias" v-if="usuarioLogado.imobiliaria.appVistoria">
              <i class="el-icon-camera-solid"></i>
              <span slot="title">Vistorias</span>
            </el-menu-item>
          </el-submenu>

          <!-- VENDA -->
          <el-submenu index="grupo-vendas" v-if="usuarioLogado.imobiliaria.moduloVenda">
            <template slot="title">
              <i class="el-icon-price-tag"></i>
              <span>Vendas</span>
            </template>
            <el-menu-item @click="toggleMenu" index="/clientes" v-if="exibirClientesVenda">
              <i class="el-icon-user-solid"></i>
              <span slot="title">Clientes</span>
            </el-menu-item>
            <el-menu-item @click="toggleMenu" index="/vendas" v-if="exibirContratosVenda">
              <i class="el-icon-document-copy"></i>
              <span slot="title">Contratos</span>
            </el-menu-item>
            <el-menu-item @click="toggleMenu" index="/imoveis" v-if="exibirImoveisVenda">
              <i class="el-icon-school"></i>
              <span slot="title">Imóveis</span>
            </el-menu-item>
          </el-submenu>

            <!-- OUTROS -->
          <!--<el-menu-item index="/caixa" v-if="exibirCaixa">
            <i class="el-icon-money"></i>
            <span slot="title">Caixa</span>
          </el-menu-item>
          <el-menu-item @click="toggleMenu" index="/atendimentos" v-if="exibirAtendimentoVenda">
            <i class="el-icon-headset"></i>
            <span slot="title">Atendimentos</span>
          </el-menu-item>-->
          <el-menu-item @click="toggleMenu" index="/historicoCobranca" v-if="permissaoHistoricoCobranca" >
            <i class="el-icon-date"></i>
            <span slot="title">Histórico de Comunicações</span>
          </el-menu-item>
          <el-menu-item index="/#" @click="logoutSistema()">
            <i class="menu-icon" style="margin-left: 5px;">
              <font-awesome-icon icon="sign-out-alt" />
            </i>
            <span>Sair</span>
          </el-menu-item>
        </el-menu>
      </div>
      <!-- DIALOGS RELATORIOS ALUGUEL -->
      <app-gerar-relatorios-clientes-aluguel-dialog @close="fecharGerarRelatoriosClientesAluguelDialog" :visibility="visibilidadeGerarRelatoriosClientesAluguel"/>
      <app-gerar-relatorios-contratos-aluguel-dialog @close="fecharGerarRelatoriosContratosAluguelDialog" :visibility="visibilidadeGerarRelatoriosContratosAluguel"/>
      <app-gerar-relatorios-imoveis-aluguel-dialog @close="fecharGerarRelatoriosImoveisAluguelDialog" :visibility="visibilidadeGerarRelatoriosImoveisAluguel"/>
      <app-gerar-relatorios-pretendentes-aluguel-dialog @close="fecharGerarRelatoriosPretendentesAluguelDialog" :visibility="visibilidadeGerarRelatoriosPretendentesAluguel"/>
      <app-gerar-relatorios-financeiros-aluguel-dialog @close="fecharGerarRelatoriosFinanceirosAluguelDialog" :visibility="visibilidadeGerarRelatoriosFinanceirosAluguel"/>
      
      <!-- DIALOGS RELATORIOS VENDA -->
      <app-gerar-relatorio-captacao-dialog @close="fecharGerarRelatorioCaptacaoDialog" :visibility="visibilidadeGerarRelatorioCaptacao"/>
      <app-gerar-relatorio-comissoes-dialog @close="fecharGerarRelatorioComissoesDialog" :visibility="visibilidadeGerarRelatorioComissoes"/>
      <app-gerar-relatorio-clientes-dialog @close="fecharGerarRelatorioClientesDialog" :visibility="visibilidadeGerarRelatorioClientes"/>
      <app-gerar-relatorio-imoveis-dialog @close="fecharGerarRelatorioImoveisDialog" :visibility="visibilidadeGerarRelatorioImoveis"/>
      <app-gerar-relatorio-pretendentes-dialog @close="fecharGerarRelatorioPretendentesDialog" :visibility="visibilidadeGerarRelatorioPretendentes"/>

      <!-- DIALOGS RELATORIOS FINANCEIROS -->
      <app-gerar-relatorios-financeiros-dialog @close="fecharRelatoriosFinanceirosDialog" :visibility="visibilidadeGerarRelatoriosFinanceiros" />
    </el-container>
  </el-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { MODULO_NOTIFICACAO, TIPO_DE_NOTIFICACAO } from "../modules/util/constantes"
import  Util from '../modules/util/funcoes'
import axios from 'axios';
import urls from "../modules/util/urls";

// ALUGUEL
import AppGerarRelatoriosClientesAluguelDialog from "../modules/alugueis/relatorios/dialogs/GerarRelatoriosClientes.vue";
import AppGerarRelatoriosContratosAluguelDialog from "../modules/alugueis/relatorios/dialogs/GerarRelatoriosContratos.vue";
import AppGerarRelatoriosImoveisAluguelDialog from "../modules/alugueis/relatorios/dialogs/GerarRelatoriosImoveis.vue";
import AppGerarRelatoriosPretendentesAluguelDialog from "../modules/alugueis/relatorios/dialogs/GerarRelatoriosPretendentes.vue";
import AppGerarRelatoriosFinanceirosAluguelDialog from "../modules/alugueis/relatorios/dialogs/GerarRelatoriosFinanceiros.vue";

// VENDA
import AppGerarRelatorioCaptacaoDialog from "../modules/vendas/relatorios/dialogs/GerarRelatorioCaptacao.vue";
import AppGerarRelatorioComissoesDialog from "../modules/vendas/relatorios/dialogs/GerarRelatorioComissoes.vue";
import AppGerarRelatorioClientesDialog from "../modules/vendas/relatorios/dialogs/GerarRelatorioClientes.vue";
import AppGerarRelatorioImoveisDialog from "../modules/vendas/relatorios/dialogs/GerarRelatorioImoveis.vue";
import AppGerarRelatorioPretendentesDialog from "../modules/vendas/relatorios/dialogs/GerarRelatorioPretendentes.vue";

// FINANCEIRO
import AppGerarRelatoriosFinanceirosDialog from "../modules/financeiro/relatorios/dialogs/GerarRelatoriosFinanceiros.vue";

export default {
  components: {
    // ALUGUEL
    AppGerarRelatoriosClientesAluguelDialog,
    AppGerarRelatoriosContratosAluguelDialog,
    AppGerarRelatoriosImoveisAluguelDialog,
    AppGerarRelatoriosPretendentesAluguelDialog,
    AppGerarRelatoriosFinanceirosAluguelDialog,

    // VENDA
    AppGerarRelatorioCaptacaoDialog,
    AppGerarRelatorioComissoesDialog,
    AppGerarRelatorioClientesDialog,
    AppGerarRelatorioImoveisDialog,
    AppGerarRelatorioPretendentesDialog,

    //FINANCEIRO
    AppGerarRelatoriosFinanceirosDialog
  },
  data() {
    return {
      // ALUGUEL
      visibilidadeGerarRelatoriosClientesAluguel: false,
      visibilidadeGerarRelatoriosContratosAluguel: false,
      visibilidadeGerarRelatoriosImoveisAluguel: false,
      visibilidadeGerarRelatoriosPretendentesAluguel: false,
      visibilidadeGerarRelatoriosFinanceirosAluguel: false,

      // VENDA
      visibilidadeGerarRelatorioCaptacao: false,
      visibilidadeGerarRelatorioComissoes: false,
      visibilidadeGerarRelatorioClientes: false,
      visibilidadeGerarRelatorioImoveis: false,
      visibilidadeGerarRelatorioPretendentes: false,

      //FINANCEIRO
      visibilidadeGerarRelatoriosFinanceiros: false,

      isExibirDetalheNotificacao: false,

      notificacaoEmExibicao: null,

      isAplicarAnimacaoDetail: false,

      sideMenuOpen: false
    };
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) {
        return state.usuarioLogado;
      },
      permissoes(state) {
        return state.usuarioLogado.permissoes;
      }
    }),

    // CAIXA
    permissoesCaixa() {
      return this.permissoes.filter(permissao => {
        return permissao.modulo == "CAIXA";
      })[0];
    },

    // ALUGUEL
    permissoesClientesAluguel() {
      return this.permissoes.filter(permissao => {
        return permissao.modulo == "CLIENTES_ALUGUEL";
      })[0];
    },
    permissoesContratosAluguel() {
      return this.permissoes.filter(permissao => {
        return permissao.modulo == "CONTRATOS_ALUGUEL";
      })[0];
    },
    permissoesImoveisAluguel() {
      return this.permissoes.filter(permissao => {
        return permissao.modulo == "IMOVEIS_ALUGUEL";
      })[0];
    },

    // PORTAIS
    permissoesPortais() {
      return this.permissoes.filter(permissao => {
        return permissao.modulo == "PORTAIS";
      })[0];
    },

    // VENDA
    exibirClientesVenda() {
      const permissoesClientesVenda = this.permissoes.filter(permissao => {
        return permissao.modulo == "CLIENTES_VENDA";
      })[0]
      if(!permissoesClientesVenda) {
        return false;
      }
      return permissoesClientesVenda.visualizacao;
    },
    exibirImoveisVenda() {
      const permissoesImoveisvenda = this.permissoes.filter(permissao => {
        return permissao.modulo == "IMOVEIS_VENDA";
      })[0]
      if(!permissoesImoveisvenda) {
        return false;
      }
      return permissoesImoveisvenda.visualizacao;
    },
    exibirContratosVenda() {
      const permissoesContratosVenda = this.permissoes.filter(permissao => {
        return permissao.modulo == "CONTRATOS_VENDA";
      })[0]
      if(!permissoesContratosVenda) {
        return false;
      }
      return permissoesContratosVenda.visualizacao;
    },
    exibirCaixa() {
      return (this.usuarioLogado.imobiliaria && this.usuarioLogado.imobiliaria.moduloFinanceiro)
        && ((this.permissoesCaixa && this.permissoesCaixa.abrirFecharCaixa) || (this.permissoesCaixa &&   this.permissoesCaixa.visualizarHistoricoCaixa));
    },
    exibirAtendimentoVenda() {
      const permissoesAtendimentoVenda = this.permissoes.filter(permissao => {
        return permissao.modulo == "PRETENDENTES";
      })[0]
      if(!permissoesAtendimentoVenda) {
        return false;
      }
      return permissoesAtendimentoVenda.visualizacao
    },

    // FINANCEIRO
    exibirGruposConta() {
      const permissoesGruposConta = this.permissoes.filter(permissao => {
        return permissao.modulo == "GRUPOS_CONTA";
      })[0]
      if(!permissoesGruposConta) {
        return false;
      }
      return permissoesGruposConta.visualizacao
    },
    exibirPlanosConta() {
      const permissoesPlanosConta = this.permissoes.filter(permissao => {
        return permissao.modulo == "PLANOS_CONTA";
      })[0]
      if(!permissoesPlanosConta) {
        return false;
      }
      return permissoesPlanosConta.visualizacao
    },
    exibirFornecedores() {
      const permissoesFornecedores = this.permissoes.filter(permissao => {
        return permissao.modulo == "FORNECEDORES";
      })[0]
      if(!permissoesFornecedores) {
        return false;
      }
      return permissoesFornecedores.visualizacao
    },
    exibirContasReceber() {
      const permissoesContasReceber = this.permissoes.filter(permissao => {
        return permissao.modulo == "CONTAS_RECEBER";
      })[0]
      if(!permissoesContasReceber) {
        return false;
      }
      return permissoesContasReceber.visualizacao
    },
    exibirContasPagar() {
      const permissoesContasPagar = this.permissoes.filter(permissao => {
        return permissao.modulo == "CONTAS_PAGAR";
      })[0]
      if(!permissoesContasPagar) {
        return false;
      }
      return permissoesContasPagar.visualizacao
    },

    // CONFIGURAÇÕES
    exibirAdministradoras() {
      const permissoesAdministradoras = this.permissoes.filter(permissao => {
        return permissao.modulo == "ADMINISTRADORAS";
      })[0]
      if(!permissoesAdministradoras) {
        return false;
      }
      return permissoesAdministradoras.visualizacao;
    },
    exibirCondominios() {
      const permissoesCondominios  = this.permissoes.filter(permissao => {
        return permissao.modulo == "CONDOMINIOS";
      })[0]
      if(!permissoesCondominios) {
        return false;
      }
      return permissoesCondominios.visualizacao;
    },
    exibirUsuarios() {
      const permissoesUsuarios = this.permissoes.filter(permissao => {
        return permissao.modulo == "USUARIOS";
      })[0]
      if(!permissoesUsuarios) {
        return false;
      }
      return permissoesUsuarios.visualizacao;
    },
    exibirPerfisUsuarios() {
      const permissoesPerfisUsuarios = this.permissoes.filter(permissao => {
        return permissao.modulo == "PERFIS_USUARIOS";
      })[0]
      if(!permissoesPerfisUsuarios) {
        return false;
      }
      return permissoesPerfisUsuarios.visualizacao;
    },
    exibirPlacas() {
      const permissoesPlacas = this.permissoes.filter(permissao => {
        return permissao.modulo == "PLACAS";
      })[0]
      if(!permissoesPlacas) {
        return false;
      }
      return permissoesPlacas.visualizacao;
    },
    exibirContasBancarias() {
      const permissoesContasBancarias = this.permissoes.filter(permissao => {
        return permissao.modulo == "CONTAS_BANCARIAS";
      })[0]
      if(!permissoesContasBancarias) {
        return false;
      }
      return permissoesContasBancarias.visualizacao;
    },
    exibirPortais() {
      if(!this.permissoesPortais) {
        return false;
      }
      return this.permissoesPortais.visualizacao;
    },
    exibirSite() {
      if(!this.permissoesPortais) {
        return false;
      }
      return this.permissoesPortais.visualizacao
        && this.usuarioLogado.imobiliaria.parametrosSite;
    },
    exibirLogs() {
      const permissoesLogs = this.permissoes.filter(permissao => {
        return permissao.modulo == "LOGS";
      })[0]
      if(!permissoesLogs) {
        return false;
      }
      return permissoesLogs.visualizacao;
    },
    exibirFormularios() {
      const permissoesFormularios = this.permissoes.filter(permissao => {
        return permissao.modulo == "SISTEMA";
      })[0]
      if(!permissoesFormularios) {
        return false;
      }
      return permissoesFormularios.alterarDiretorioFormularios;
    },
    exibirParametros() {
      const permissoesParametros = this.permissoes.filter(permissao => {
        return permissao.modulo == "SISTEMA";
      })[0]
      if(!permissoesParametros) {
        return false;
      }
      return permissoesParametros.alterarParametros;
    },

    // RELATORIOS - VENDA

    exibirRelatoriosCaptacoes() {
      const permissoesRelatoriosCaptacoes = this.permissoes.filter(permissao => {
        return permissao.modulo == "RELATORIOS_CAPTACOES_VENDA";
      })[0]
      if(!permissoesRelatoriosCaptacoes) {
        return false;
      }
      return permissoesRelatoriosCaptacoes.visualizacao
    },
    exibirRelatoriosComissoes() {
      const permissoesRelatoriosComissoes = this.permissoes.filter(permissao => {
        return permissao.modulo == "RELATORIOS_COMISSOES_VENDA";
      })[0]
      if(!permissoesRelatoriosComissoes) {
        return false;
      }
      return permissoesRelatoriosComissoes.visualizacao;
    },
    exibirRelatoriosClientes() {
      const permissoesRelatoriosClientes = this.permissoes.filter(permissao => {
        return permissao.modulo == "RELATORIOS_CLIENTES_VENDA";
      })[0]
      if(!permissoesRelatoriosClientes) {
        return false;
      }
      return permissoesRelatoriosClientes.visualizacao
    },
    exibirRelatoriosImoveis() {
      const permissoesRelatoriosImoveis = this.permissoes.filter(permissao => {
        return permissao.modulo == "RELATORIOS_IMOVEIS_VENDA";
      })[0]
      if(!permissoesRelatoriosImoveis) {
        return false;
      }
      return permissoesRelatoriosImoveis.visualizacao
    },
    exibirRelatoriosPretendentes() {
      const permissoesRelatoriosPretendentes = this.permissoes.filter(permissao => {
        return permissao.modulo == "RELATORIOS_PRETENDENTES_VENDA";
      })[0]
      if(!permissoesRelatoriosPretendentes) {
        return false;
      }
      return permissoesRelatoriosPretendentes.visualizacao
    },
    // RELATORIOS - ALUGUEL
    exibirRelatoriosClientesAluguel() {
      const permissoesRelatoriosClientesAluguel = this.permissoes.filter(permissao => {
        return permissao.modulo == "RELATORIOS_CLIENTES_ALUGUEL";
      })[0]
      if(!permissoesRelatoriosClientesAluguel) {
        return false;
      }
      return permissoesRelatoriosClientesAluguel.visualizacao
    },
    exibirRelatoriosContratosAluguel() {
      return this.permissoesRelatoriosContratosAluguel && this.permissoesRelatoriosContratosAluguel.relatorioContratosAtivos
        || this.permissoesRelatoriosContratosAluguel && this.permissoesRelatoriosContratosAluguel.relatorioContratosNovos
        || this.permissoesRelatoriosContratosAluguel && this.permissoesRelatoriosContratosAluguel.relatorioContratosRenovados
        || this.permissoesRelatoriosContratosAluguel && this.permissoesRelatoriosContratosAluguel.relatorioContratosVencidos
        || this.permissoesRelatoriosContratosAluguel && this.permissoesRelatoriosContratosAluguel.relatorioContratosFinalizados
        || this.permissoesRelatoriosContratosAluguel && this.permissoesRelatoriosContratosAluguel.relatorioContratosEfetivados
        || this.permissoesRelatoriosContratosAluguel && this.permissoesRelatoriosContratosAluguel.relatorioContratosDeclararIr;
    },
    
    exibirRelatoriosImoveisAluguel() {
      return this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioImoveisCaptadosPorCaptador
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioImoveisCaptadosPorTipoDeImovel
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioImoveisParaAluguel
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioImoveisPorCliente
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioImoveisPorCondominio
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioImoveisComPlaca
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioImoveisSemPlaca
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioImoveisSemFotos
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioImoveisReservados
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioImoveisPublicadosSite
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioImoveisAcompanhamento
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioResumoAdministradoras
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioMatriculasImoveis
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioVisitasPorPeriodo
        || this.permissoesRelatoriosImovelAluguel && this.permissoesRelatoriosImovelAluguel.relatorioVistoriasPorPeriodo;
    },

    exibirRelatoriosAluguel() {
      return this.exibirRelatoriosClientesAluguel
        || this.exibirRelatoriosContratosAluguel
        || this.exibirRelatoriosImoveisAluguel
        || this.exibirRelatoriosPretendentesAluguel
        || this.exibirRelatoriosFinanceirosAluguel
    },

    exibirRelatoriosVenda() {
      return this.exibirRelatoriosCaptacoes
        || this.exibirRelatoriosComissoes
        || this.exibirRelatoriosClientes
        || this.exibirRelatoriosImoveis
        || this.exibirRelatoriosPretendentes
    },

    exibirBaixasAluguel() {
      return this.permissoesClientesAluguel && this.permissoesClientesAluguel.pagarAluguel
        || this.permissoesClientesAluguel && this.permissoesClientesAluguel.processarArquivoBancario
        || this.permissoesClientesAluguel && this.permissoesClientesAluguel.liberarRepasse
    },

    exibirRelatoriosPretendentesAluguel() {
      const permissoesRelatoriosPretendentesAluguel = this.permissoes.filter(permissao => {
        return permissao.modulo == "RELATORIOS_PRETENDENTES_ALUGUEL";
      })[0]
      if(!permissoesRelatoriosPretendentesAluguel) {
        return false;
      }
      return permissoesRelatoriosPretendentesAluguel.visualizacao
    },
    exibirRelatoriosFinanceirosAluguel() {
      return this.permissoesRelatoriosFinanceirosAluguel && this.permissoesRelatoriosFinanceirosAluguel.relatorioPrevisaoRepasses
        || this.permissoesRelatoriosFinanceirosAluguel && this.permissoesRelatoriosFinanceirosAluguel.relatorioPrevisaoRecebimentos
        || this.permissoesRelatoriosFinanceirosAluguel && this.permissoesRelatoriosFinanceirosAluguel.relatorioRepassesRealizados
        || this.permissoesRelatoriosFinanceirosAluguel && this.permissoesRelatoriosFinanceirosAluguel.relatorioRepassesEfetivadosPeriodo
        || this.permissoesRelatoriosFinanceirosAluguel && this.permissoesRelatoriosFinanceirosAluguel.relatorioRepassesAtrasados
        || this.permissoesRelatoriosFinanceirosAluguel && this.permissoesRelatoriosFinanceirosAluguel.relatorioAlugueisRecebidos
        || this.permissoesRelatoriosFinanceirosAluguel && this.permissoesRelatoriosFinanceirosAluguel.relatorioAlugueisAtrasados
        || this.permissoesRelatoriosFinanceirosAluguel && this.permissoesRelatoriosFinanceirosAluguel.relatorioBoletosAvulsos
        || this.permissoesRelatoriosFinanceirosAluguel && this.permissoesRelatoriosFinanceirosAluguel.relatorioRemessasGeradas
        || this.permissoesRelatoriosFinanceirosAluguel && this.permissoesRelatoriosFinanceirosAluguel.relatorioDesempenhoLocacao
        || this.permissoesRelatoriosFinanceirosAluguel && this.permissoesRelatoriosFinanceirosAluguel.relatorioResumoCarteira
    },

    permissoesModuloContasPagar() {
      return this.permissoes.filter(permissao => {
        return permissao.modulo === 'CONTAS_PAGAR'
      })[0];
    },

    permissoesModuloContasReceber() {
      return this.permissoes.filter(permissao => {
        return permissao.modulo === 'CONTAS_RECEBER'
      })[0];
    },
    
    exibirRelatoriosFinanceiros() {
      return this.permissoesModuloContasPagar && this.permissoesModuloContasPagar.relatorioContasPagas
        || this.permissoesModuloContasPagar && this.permissoesModuloContasPagar.relatorioContasAPagar
        || this.permissoesModuloContasPagar && this.permissoesModuloContasPagar.relatorioContasAPagarVencidas
        || this.permissoesModuloContasReceber && this.permissoesModuloContasReceber.relatorioContasRecebidas
        || this.permissoesModuloContasReceber && this.permissoesModuloContasReceber.relatorioContasAReceber
        || this.permissoesModuloContasReceber && this.permissoesModuloContasReceber.relatorioContasAReceberVencidas
        || this.permissoesModuloContasReceber && this.permissoesModuloContasReceber.relatorioCheques
    },

    permissoesRelatoriosContratosAluguel() {
      return this.permissoes.filter(permissao => {
        return permissao.modulo === 'RELATORIOS_CONTRATOS_ALUGUEL'
      })[0];
    },

    permissoesRelatoriosImovelAluguel() {
      return this.permissoes.filter(permissao => {
        return permissao.modulo === 'RELATORIOS_IMOVEIS_ALUGUEL'
      })[0];
    },

    permissoesRelatoriosFinanceirosAluguel() {
      return this.permissoes.filter(permissao => {
        return permissao.modulo === 'RELATORIOS_FINANCEIROS_ALUGUEL'
      })[0];
    },

    loading() {
      return this.$store.state.loading;
    },
    
    permissaoHistoricoCobranca() {
      return this.usuarioLogado.imobiliaria.moduloAluguel == true && (this.permissoesContratosAluguel && this.permissoesContratosAluguel.visualizacao)
    },

    notificacoes() {
      return this.usuarioLogado.notificacoes;
    },

    moduloNotificacao() {
      return MODULO_NOTIFICACAO;
    },

    tipoNotificacao() {
      return TIPO_DE_NOTIFICACAO;
    },

    countNotificacoesNaoVisualizadas() {
      return this.notificacoes.filter(notificacao => { return notificacao.status === 'NAO_VISUALIZADA' }).length
    }
  },
  methods: {
    ...mapActions("alugueisContratosStore", [
      "recuperarAluguel"
    ]),
    ...mapActions("vendasContratosStore", [
      "recuperarVenda"
    ]),
    ...mapActions("alugueisClientesStore", [
      "recuperarClienteAluguel"
    ]),
    ...mapActions("vendasClientesStore",[
      "recuperarClienteVenda"
    ]),
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions('loginStore', [
      'relogar',
      'capturarLocalizacaoImobiliaria'
    ]),

    ...mapActions("loginStore", ["logout"]),
    // RELATORIOS - ALUGUEL
    fecharGerarRelatoriosClientesAluguelDialog() {
      this.visibilidadeGerarRelatoriosClientesAluguel = false;
    },
    fecharGerarRelatoriosContratosAluguelDialog() {
      this.visibilidadeGerarRelatoriosContratosAluguel = false;
    },
    fecharGerarRelatoriosImoveisAluguelDialog() {
      this.visibilidadeGerarRelatoriosImoveisAluguel = false;
    },
    fecharGerarRelatoriosPretendentesAluguelDialog() {
      this.visibilidadeGerarRelatoriosPretendentesAluguel = false;
    },
    fecharGerarRelatoriosFinanceirosAluguelDialog() {
      this.visibilidadeGerarRelatoriosFinanceirosAluguel = false;
    },
    // RELATORIOS - VENDA
    fecharGerarRelatorioCaptacaoDialog() {
      this.visibilidadeGerarRelatorioCaptacao = false;
    },
    fecharGerarRelatorioComissoesDialog() {
      this.visibilidadeGerarRelatorioComissoes = false;
    },
    fecharGerarRelatorioClientesDialog() {
      this.visibilidadeGerarRelatorioClientes = false;
    },
    fecharGerarRelatorioImoveisDialog() {
      this.visibilidadeGerarRelatorioImoveis = false;
    },
    fecharGerarRelatorioPretendentesDialog() {
      this.visibilidadeGerarRelatorioPretendentes = false;
    },
    // RELATORIOS - FINANCEIRO
    fecharRelatoriosFinanceirosDialog() {
      this.visibilidadeGerarRelatoriosFinanceiros = false;
    },
    // LOGOUT
    logoutSistema() {
      this.logout().then(() => {
        //this.$router.push("/login");
        this.$router.go();
      });
    },

    getLabel(data, label) {
      return Util.getLabel(data, label)
    },

    getDataModule(notification) {
      if(notification.cliente.id > 0) {
        return notification.cliente.nome;
      }

      if(notification.imovel.id > 0) {
        return notification.imovel.idNaImobiliaria;
      }

      if(notification.aluguel.id > 0) {
        return notification.aluguel.idNaImobiliaria;
      }

      if(notification.venda.id > 0) {
        return notification.venda.imovel.idNaImobiliaria;
      }
    },

    redirectNotificacao(notificacao) {
      switch (notificacao.modulo) {
        case "ALUGUEL_CONTRATO":
          this.recuperarAluguelNotificacao(notificacao.aluguel);
          break;
        case "VENDA_CONTRATO":
          this.recuperarVendaNotificacao(notificacao.venda);
          break;
        case "ALUGUEL_CLIENTE":
          this.recuperarClienteAluguelNotificacao(notificacao.cliente);
          break;
        case "VENDA_CLIENTE":
          this.recuperarClienteVendaNotificacao(notificacao.cliente);
          break;
      }
    },

    recuperarAluguelNotificacao(aluguel) {
      this.showLoading();
      this.recuperarAluguel(aluguel)
      .then(resultado => {
        this.hideLoading();
        if(resultado.status == "SUCESSO") {
          this.$router.push("/alugueis")
        }
        this.hideLoading();
      })
      .catch(() => {
        this.$message.error("Não foi possível recuperar o contrato.");
        this.hideLoading();
      })
    },

    recuperarVendaNotificacao(venda) {
      let payload = { id: venda.id }
      this.showLoading();
      this.recuperarVenda(payload)
        .then(resultado => {
          this.hideLoading();
          if(resultado.status == "SUCESSO") {
            this.$router.push("/vendas");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message("Não foi possível se comunicar com o servidor.");
          this.hideLoading();
        })
    },
    
    recuperarClienteAluguelNotificacao(cliente) {
      this.showLoading();
      this.recuperarClienteAluguel(cliente)
      .then(resultado => {
        this.hideLoading();
        if(resultado.status == "SUCESSO") {
          this.$router.push("/alugueis/clientes")
        }
        this.hideLoading();
      })
      .catch(() => {
        this.$message.error("Não foi possível recuperar o cliente.");
        this.hideLoading();
      })
    },

    recuperarClienteVendaNotificacao(cliente) {
      this.showLoading();
      this.recuperarClienteVenda(cliente)
      .then(resultado => {
        this.hideLoading();
        if(resultado.status == "SUCESSO") {
          this.$router.push("/clientes")
        }
        this.hideLoading();
      })
      .catch(() => {
        this.$message.error("Não foi possível recuperar o cliente.");
        this.hideLoading();
      })
    },

    exibirDetalhesNotificacoes(notificacao) {
      this.notificacaoEmExibicao = notificacao;

      if(notificacao.status !== 'VISUALIZADA') {
        this.visualizarNotificacao(notificacao);
      }
      this.isExibirDetalheNotificacao = true;
    },

    fecharDetalhesNotificacoes() {
      this.notificacaoEmExibicao = null;
      this.isExibirDetalheNotificacao = false;
    },

    visualizarNotificacao(payload) {
      axios.post(urls.VISUALIZAR_NOTIFICACAO, payload).
      then(resultado => {
        if(resultado.data.status === 'SUCESSO') {
          this.usuarioLogado.notificacoes = resultado.data.lista;
        } else if(resultado.data.status === 'SESSAO_EXPIRADA') {
          this.relogar().then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              axios.post(urls.VISUALIZAR_NOTIFICACAO, payload)
              .then((resposta) => {
                if(resposta.data.status == "SUCESSO") {
                  this.usuarioLogado.notificacoes = resposta.data.lista;
                }
              }).catch(error => {
                throw error;
              })
            }
          })
        }
      }).catch((error) => {throw error})
    },

    openCloseSideMenu() {
      this.sideMenuOpen = !this.sideMenuOpen;
    },

    toggleMenu() {
      this.sideMenuOpen = false;
    }
  },
};
</script>

<style>
.el-header {
  background-color: #EFF3FA;
  color: #333;
  text-align: center;
  padding: 0px;
}

.application-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 100vh !important;
}

.application-main {
  background-color: #ffff;
  color: #333;
  text-align: center;
  padding: 0px;

  position: absolute;
  top: 60px;
  left: 65px;
  bottom: 0px;
  right: 0px;
}

.menu-icon {
  width: 10px;
  margin-right: 8px;
  font-size: 17px;
}

.application-container .el-loading-mask {
  z-index: 100000;
}

.el-menu--popup {
  border-radius: 0px;
  padding: 0px;
}

.el-menu--popup-right-start {
  margin: 0px;
}

.el-menu--popup-bottom-start {
  margin-top: 0px;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  height: 50px;
  line-height: 50px;
}

.general-menu i {
  color: #ffff;
}

.el-menu-item li:hover> {
  background-color: #EFF3FA;
}

.global-task-bar-button {
  box-shadow: 1px 1px 6px 0px grey;
  border: none;
}

.item {
  margin-top: 0px;
  margin-right: 0px
}

.avatar:hover {
  cursor: pointer;
}

.container-notifications-not {
  background-color: #c0d1ee;
  border-radius: 10px;
  height: 25rem;
  width: 18rem;
  padding: 0px 5px 0px 5px;
}

.container-notifications-no-not {
  height: 25rem;
  width: 18rem;
  padding: 0px 5px 0px 5px;
  background-color: #c0d1ee;
}

.container-notifications-detail {
  height: 25rem;
  width: 18rem;
  padding: 5px 5px 0px 5px;
}

.el-popover {
  border-radius: 10px !important;
  background-color: #426e86 !important;
  padding: 5px;
}

.table-notifications {
  border-radius: 10px;
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  padding: 5px 0px 5px 0px;
  gap: 5px;

  overflow-y: auto;
  overflow-x: hidden;

  color: #1D1E1F;
}

.table-notifications::-webkit-scrollbar{
  width: 0px;
}

.notification-cell {
  width: 20em;
  height: 4em;

  box-shadow: 1px 1px 3px 1px #cacaca;
  border-radius: 10px;
  padding: 5px;
}

.notification-cell:hover {
  cursor: pointer;
}

.direct-button {
  text-decoration: underline;
  font-style: italic;
}

.direct-button:hover {
  cursor: pointer;
  color: #4235f8;
}

.details-notifications {
  background-color: #ffffff;
  height: 24.3rem;
  width: 17.3rem;

  border-radius: 10px;
  padding: 0px 5px 0px 5px;
  overflow: auto;
}

.animation-tb-detail-in {
  animation: tb-detail-to-left 0.3s, fadeIn 0.3s;
}


@keyframes tb-detail-to-left {
  0% {
    transform: translateX(350px)
  }
  100% {
    transform: translateX(0px);
  }
}

@keyframes fadeIn {
  0% { opacity: 0; }
  60% { opacity: 0; }
  100% { opacity: 1; }
}

.container-no-notifications {
  height: 25rem;
  width: 18rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.no-wrap-description {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  text-align: left;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.drawer-menu {
  display: none;
}

@media screen and (max-width: 465px) {
  .application-main {
    top: 60px;
    left: 0px;
  }

  .menu-item-desktop {
    display: none;
  }

  .nome-usuario {
    display: none;
  }

  .drawer-menu {
    display: block;
  }

  .drawer-menu:focus {
    background-color: transparent !important;
  }

  .drawer-menu:hover {
    background-color: transparent !important;
  }

  .drawer-menu {
    color: rgb(255, 255, 255) !important;
    border-bottom-color: transparent !important;
  }

  .no-scrollbar::-webkit-scrollbar {
    width: 0px;
  }

  .application-container {
    height: 100% !important;
  }

  .application-main::-webkit-scrollbar {
    width: 0px;
  }
}

.animation-show-side-menu {
  animation: show-side-menu 0.3s;
}

.close-side-menu {
  display: none;
}

@keyframes show-side-menu{
  0% {
    transform: translateX(-200px)
  }
  100% {
    transform: translateX(0px);
  }
}
</style>
